import { useEffect, useState } from "react";
import ModalComponent from "components/modal";
import { addLocation, changeLocationStatus } from "api/location";
import { useSharedState } from "state";
import Table from "components/table";
import ActionButton from "components/table/action-btn";
import { oneLine } from "components/table/table-parts";
import { IconLock, IconLockOpen, IconX } from "@tabler/icons-react";
import { LocationType, LocationDefault } from "types/dict";
import WarningModal from "components/modal/warning";

export default function Locations() {
  const { locations, getLocationsData, notify } = useSharedState();

  const [locationToChange, setLocationToChange] = useState<LocationType>(LocationDefault);
  const [isAddingLocation, setAddingLocation] = useState<boolean>(false);
  const [isFormLoading, setFormLoading] = useState<boolean>(false);

  const [newLocationName, setNewLocationName] = useState<string>("");

  const ChangeStatusDanger = "Вы действительно хотите изменить статус филиала?";

  useEffect(() => {
    getLocationsData();
  }, []);

  const openLocationModal = () => {
    const button = document.createElement("button");
    button.setAttribute("data-bs-toggle", "modal");
    button.setAttribute("data-bs-target", "#modal");
    document.body.appendChild(button);
    button.click();
    button.remove();
  };

  const cancelLocationCreation = () => {
    setNewLocationName("");
    setAddingLocation(false);
  };

  const onChangeLocationStatus = async () => {
    openLocationModal();
    setFormLoading(true);

    try {
      await changeLocationStatus(locationToChange.location_id, !locationToChange.status);
      notify("Статус изменён", "success");

      getLocationsData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при смене статуса");
    } finally {
      setFormLoading(false);
    }
  };

  const createLocation = async () => {
    setFormLoading(true);

    try {
      await addLocation(newLocationName);
      notify("Филиал добавлен", "success");

      cancelLocationCreation();
      getLocationsData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при добавлении филиала");
    } finally {
      setFormLoading(false);
    }
  };

  const locationsTableHeaders = [
    { header_text: "Филиал", narrow: false, wrap: false },
    { header_text: "Статус", narrow: false, wrap: false },
    { header_text: "Действия", narrow: false, wrap: false },
  ];

  const locationsList = (
    <>
      {locations.map((location, index) => (
        <tr key={index}>
          <td>{oneLine(location.location)}</td>
          <td>{oneLine(location.status ? "Активный" : "Неактивный", location.status ? "success" : "danger")}</td>
          <td>
            <ActionButton
              icon={location.status ? <IconLock className="icon" /> : <IconLockOpen className="icon" />}
              title={`${location.status ? "Деактивировать" : "Активировать"}`}
              action={() => setLocationToChange(location)}
              color={`${location.status ? "danger" : "success"}`}
              modal={true}
              modal_id="#modal-block-location"
            />
          </td>
        </tr>
      ))}

      {isAddingLocation && (
        <tr>
          <td>
            <input
              type="text"
              className="form-control"
              placeholder="Название нового филиала"
              value={newLocationName}
              onChange={(e) => setNewLocationName(e.target.value)}
              disabled={isFormLoading}
            />
          </td>
          <td></td>
          <td>
            <ActionButton
              icon={<IconX className="icon" />}
              title="Отмена"
              action={cancelLocationCreation}
              color="danger"
              modal={false}
            />
          </td>
        </tr>
      )}
    </>
  );

  const usersTable = Table(locationsTableHeaders, locationsList, false);

  const locationsFooter = (
    <button
      className="btn btn-success d-flex gap-1"
      onClick={isAddingLocation ? createLocation : () => setAddingLocation(true)}
      disabled={isFormLoading || (isAddingLocation && !newLocationName?.length)}
    >
      {isAddingLocation ? "Сохранить" : "Добавить филиал"}
      {isFormLoading && <div className="spinner-border spinner-border-sm" role="status" />}
    </button>
  );

  return (
    <>
      <ModalComponent
        header="Список филиалов"
        body={usersTable}
        footer={locationsFooter}
        disableClose={isFormLoading}
      />
      <WarningModal
        modal_id="modal-block-location"
        warningDescription={ChangeStatusDanger}
        cancel={openLocationModal}
        confirm={onChangeLocationStatus}
      />
    </>
  );
}
